<template>
  <div class="navigation">
  
    <router-link
      v-for="item in navigationItems"
      :key="item.name"
      :to="{ name: item.name }"
      :class="$route.path.match(new RegExp(`^\/${item.name}`)) ? 'navigation-active' : 'navigation-default'"
      class="navigation-item"
    >
      <component
        :is="`${item.name}-icon`"
        class="icon"
        :fill="$route.path.match(new RegExp(`^\/${item.name}`)) ? '#fff' : '#0099da'"
      />
      <span>{{ item.label }}</span>
    </router-link>
  </div>
</template>

<script>
import IndicatorsIcon from '@/components/icons/IndicatorsIcon.vue';
import ModelsIcon from '@/components/icons/ModelsIcon.vue';
import BannerIcon from '@/components/icons/BannerIcon.vue';

export default {
  name: 'navigation',

  components: {
    IndicatorsIcon,
    ModelsIcon,
    BannerIcon,
  },

  data() {
    return {
      navigationItems: [
        {
          name: 'indicators',
          label: 'Индикаторы',
        },
        {
          name: 'models',
          label: 'Модели',
        },
        {
          name: 'banner',
          label: 'Баннер',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.navigation {
  padding: 20px 0px;

  .navigation-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 40px;
    cursor: pointer;
    text-decoration: none;

    &.navigation-active {
      background: var(--main-brand-color);
      color: var(--white-text-color);
    }

    &.navigation-default {
      background: none;
      color: var(--gray-text-color);
    }

    .icon {
      width: 18px;
      height: 18px;
    }

    span {
      margin-left: 10px;
    }
  }
}
</style>
